import { KEY_WORD_SEPARATOR } from '../Strings/_consts';
export function parseKey(key) {
    return key.split(KEY_WORD_SEPARATOR);
}
